import CARDS_IN_SPACE_MEDAL_IMAGE_URL from '../assets/medals/cards-in-space-medal.png';
import CHAMPS_MEDAL_IMAGE_URL from '../assets/medals/champs-medal.png';
import CHIPS_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/chips-level1-medal.png';
import CHIPS_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/chips-level2-medal.png';
import CHIPS_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/chips-level3-medal.png';
import CHIPS_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/chips-level4-medal.png';
import HANDS_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/hands-level1-medal.png';
import HANDS_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/hands-level2-medal.png';
import HANDS_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/hands-level3-medal.png';
import HANDS_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/hands-level4-medal.png';
import INSOMNIAC_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/insomniac-level1-medal.png';
import INSOMNIAC_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/insomniac-level2-medal.png';
import INSOMNIAC_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/insomniac-level3-medal.png';
import INSOMNIAC_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/insomniac-level4-medal.png';
import JACKPOT_MEDAL_IMAGE_URL from '../assets/medals/jackpot-medal.png';
import OLD_TIMER_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level1-medal.png';
import OLD_TIMER_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level2-medal.png';
import OLD_TIMER_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level3-medal.png';
import OLD_TIMER_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level4-medal.png';
import OLD_TIMER_LEVEL5_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level5-medal.png';
import OLD_TIMER_LEVEL6_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level6-medal.png';
import OLD_TIMER_LEVEL7_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level7-medal.png';
import OLD_TIMER_LEVEL8_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level8-medal.png';
import OLD_TIMER_LEVEL9_MEDAL_IMAGE_URL from '../assets/medals/old-timer-level9-medal.png';
import PIGGY_MEDAL_IMAGE_URL from '../assets/medals/piggy-medal.png';
import POWER_PLAYER_MEDAL_IMAGE_URL from '../assets/medals/power-player-medal.png';
import RIOT_MEDAL_IMAGE_URL from '../assets/medals/riot-medal.png';
import ROYAL_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/royal-level1-medal.png';
import ROYAL_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/royal-level2-medal.png';
import ROYAL_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/royal-level3-medal.png';
import ROYAL_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/royal-level4-medal.png';
import ROYAL_LEVEL5_MEDAL_IMAGE_URL from '../assets/medals/royal-level5-medal.png';
import ROYAL_LEVEL6_MEDAL_IMAGE_URL from '../assets/medals/royal-level6-medal.png';
import SIDE_BETS_PROFIT_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/side-bets-profit-level1-medal.png';
import SIDE_BETS_PROFIT_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/side-bets-profit-level2-medal.png';
import SIDE_BETS_PROFIT_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/side-bets-profit-level3-medal.png';
import SIDE_BETS_PROFIT_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/side-bets-profit-level4-medal.png';
import SIDE_BETS_WON_LEVEL1_MEDAL_IMAGE_URL from '../assets/medals/side-bets-won-level1-medal.png';
import SIDE_BETS_WON_LEVEL2_MEDAL_IMAGE_URL from '../assets/medals/side-bets-won-level2-medal.png';
import SIDE_BETS_WON_LEVEL3_MEDAL_IMAGE_URL from '../assets/medals/side-bets-won-level3-medal.png';
import SIDE_BETS_WON_LEVEL4_MEDAL_IMAGE_URL from '../assets/medals/side-bets-won-level4-medal.png';
import { getCurrencyAmountString } from '../utils/currencyUtils';
export { POWER_PLAYER_MEDAL_IMAGE_URL, ROYAL_LEVEL1_MEDAL_IMAGE_URL, ROYAL_LEVEL2_MEDAL_IMAGE_URL, ROYAL_LEVEL3_MEDAL_IMAGE_URL, ROYAL_LEVEL4_MEDAL_IMAGE_URL, ROYAL_LEVEL5_MEDAL_IMAGE_URL, ROYAL_LEVEL6_MEDAL_IMAGE_URL };
const CHIPS_MEDAL_IMAGE_URLS_BY_LEVEL = [
    CHIPS_LEVEL1_MEDAL_IMAGE_URL,
    CHIPS_LEVEL2_MEDAL_IMAGE_URL,
    CHIPS_LEVEL3_MEDAL_IMAGE_URL,
    CHIPS_LEVEL4_MEDAL_IMAGE_URL
];
const HANDS_MEDAL_IMAGE_URLS_BY_LEVEL = [
    HANDS_LEVEL1_MEDAL_IMAGE_URL,
    HANDS_LEVEL2_MEDAL_IMAGE_URL,
    HANDS_LEVEL3_MEDAL_IMAGE_URL,
    HANDS_LEVEL4_MEDAL_IMAGE_URL
];
const INSOMNIAC_MEDAL_IMAGE_URLS_BY_LEVEL = [
    INSOMNIAC_LEVEL1_MEDAL_IMAGE_URL,
    INSOMNIAC_LEVEL2_MEDAL_IMAGE_URL,
    INSOMNIAC_LEVEL3_MEDAL_IMAGE_URL,
    INSOMNIAC_LEVEL4_MEDAL_IMAGE_URL
];
const SIDE_BETS_WON_MEDAL_IMAGE_URLS_BY_LEVEL = [
    SIDE_BETS_WON_LEVEL1_MEDAL_IMAGE_URL,
    SIDE_BETS_WON_LEVEL2_MEDAL_IMAGE_URL,
    SIDE_BETS_WON_LEVEL3_MEDAL_IMAGE_URL,
    SIDE_BETS_WON_LEVEL4_MEDAL_IMAGE_URL
];
const SIDE_BETS_PROFIT_MEDAL_IMAGE_URLS_BY_LEVEL = [
    SIDE_BETS_PROFIT_LEVEL1_MEDAL_IMAGE_URL,
    SIDE_BETS_PROFIT_LEVEL2_MEDAL_IMAGE_URL,
    SIDE_BETS_PROFIT_LEVEL3_MEDAL_IMAGE_URL,
    SIDE_BETS_PROFIT_LEVEL4_MEDAL_IMAGE_URL
];
const ROYAL_MEDAL_IMAGE_URLS_BY_LEVEL = [
    ROYAL_LEVEL1_MEDAL_IMAGE_URL,
    ROYAL_LEVEL2_MEDAL_IMAGE_URL,
    ROYAL_LEVEL3_MEDAL_IMAGE_URL,
    ROYAL_LEVEL4_MEDAL_IMAGE_URL,
    ROYAL_LEVEL5_MEDAL_IMAGE_URL,
    ROYAL_LEVEL6_MEDAL_IMAGE_URL
];
const OLD_TIMER_MEDAL_IMAGE_URLS_BY_LEVEL = [
    OLD_TIMER_LEVEL1_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL2_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL3_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL4_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL5_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL6_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL7_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL8_MEDAL_IMAGE_URL,
    OLD_TIMER_LEVEL9_MEDAL_IMAGE_URL
];
/**
 * Returns an index into an array of medal images, where there are assumed to be 4 available medal levels
 * (4 image URLs in the array) and 25 visible ranked places. In other words, this function maps 25 ranked
 * places onto 4 visibly distinct medal "levels".
 */
function getLevelIndexFromRank(rank) {
    if (rank === undefined) {
        return;
    }
    if (rank === 1) {
        return 0;
    }
    if (rank <= 5) {
        return 1;
    }
    if (rank <= 15) {
        return 2;
    }
    return 3;
}
const getWinnerStr = (quantity) => `Winner x${quantity.toLocaleString()}`;
export function getImageUrlFromRank(rank, imageUrls) {
    const levelIndex = getLevelIndexFromRank(rank);
    if (levelIndex === undefined) {
        return;
    }
    return imageUrls[levelIndex]; // could be undefined if array element doesn't exist
}
function getImageUrlFromRankedMedal({ rank }, imageUrls) {
    return getImageUrlFromRank(rank, imageUrls);
}
export const ALL_MEDAL_PROPERTIES = {
    pp: {
        name: 'Power Player',
        description: 'Awarded to all active Power Players. Only shown on seated players if it is their only medal.',
        getImageUrl: () => POWER_PLAYER_MEDAL_IMAGE_URL,
        sampleImageUrl: POWER_PLAYER_MEDAL_IMAGE_URL
    },
    chips: {
        name: 'Chips',
        description: 'Ranks active Power Players according to how many Chips are in their bank.',
        rankingType: 'chips',
        getImageUrl: (playerMedal) => getImageUrlFromRankedMedal(playerMedal, CHIPS_MEDAL_IMAGE_URLS_BY_LEVEL),
        sampleImageUrl: CHIPS_LEVEL4_MEDAL_IMAGE_URL,
        gameGuideDetailPageType: 'chips-medal',
        rankedMedalImageUrls: CHIPS_MEDAL_IMAGE_URLS_BY_LEVEL
    },
    hands_played: {
        name: 'Hands Played',
        description: 'Ranks active Power Players according to how many hands they have played.',
        rankingType: 'hands-played',
        getImageUrl: (playerMedal) => getImageUrlFromRankedMedal(playerMedal, HANDS_MEDAL_IMAGE_URLS_BY_LEVEL),
        sampleImageUrl: HANDS_LEVEL1_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ value }) => (value ? [`${value.toLocaleString()} Hands Played`] : []),
        gameGuideDetailPageType: 'hands-played-medal',
        rankedMedalImageUrls: HANDS_MEDAL_IMAGE_URLS_BY_LEVEL
    },
    royal: {
        name: 'Royal Flush Club',
        description: 'Awarded to players who have gotten one or more Royal Flush hands.',
        getImageUrl: ({ value }) => (value !== undefined ? ROYAL_MEDAL_IMAGE_URLS_BY_LEVEL[value - 1] : undefined),
        sampleImageUrl: ROYAL_LEVEL3_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ value, quantity }) => {
            function getTypeText() {
                // these values are from a calculation done on the server based on the player's number and type of royal flushes
                if (value === 1) {
                    return 'Hard Rainbow';
                }
                if (value === 2) {
                    return 'Rainbow';
                }
                if (value === 3) {
                    return 'Hard Multi';
                }
                if (value === 4) {
                    return 'Hard';
                }
                if (value === 5) {
                    return 'Multi';
                }
            }
            const infoItems = [];
            const typeText = getTypeText();
            if (typeText) {
                infoItems.push(`"${typeText}"`);
            }
            infoItems.push(`${quantity.toLocaleString()} Total`);
            return infoItems;
        },
        gameGuideDetailPageType: 'royal-flush-club-medal'
    },
    insomniac: {
        name: 'Insomniac',
        isDisabled: true,
        description: "Ranks active Power Players according to how many hands they've played in the past day.",
        rankingType: 'insomniac',
        getImageUrl: (playerMedal) => getImageUrlFromRankedMedal(playerMedal, INSOMNIAC_MEDAL_IMAGE_URLS_BY_LEVEL),
        sampleImageUrl: INSOMNIAC_LEVEL3_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ value }) => (value ? [`${value.toLocaleString()} Hands in Past Day`] : []),
        gameGuideDetailPageType: 'insomniac-medal',
        rankedMedalImageUrls: INSOMNIAC_MEDAL_IMAGE_URLS_BY_LEVEL
    },
    piggy: {
        name: 'Greedy Pig',
        description: 'Awarded if you win 10 Greedy Pig tournaments, and tracks the number of wins.',
        getImageUrl: ({ quantity }) => (quantity >= 10 ? PIGGY_MEDAL_IMAGE_URL : undefined),
        sampleImageUrl: PIGGY_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ quantity }) => [getWinnerStr(quantity)],
        gameGuideDetailPageType: 'piggy-medal'
    },
    champs: {
        name: 'Monthly Champ',
        description: 'Awarded if you win a Monthly Champ Finals tournament, and tracks the number of wins.',
        getImageUrl: () => CHAMPS_MEDAL_IMAGE_URL,
        sampleImageUrl: CHAMPS_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ quantity }) => [getWinnerStr(quantity)]
    },
    rocket: {
        name: 'Cards In Space',
        description: 'Awarded if you win 10 Cards In Space tournaments, and tracks the number of wins.',
        infoItemsCreator: ({ quantity }) => [getWinnerStr(quantity)],
        getImageUrl: ({ quantity }) => (quantity >= 10 ? CARDS_IN_SPACE_MEDAL_IMAGE_URL : undefined),
        sampleImageUrl: CARDS_IN_SPACE_MEDAL_IMAGE_URL,
        gameGuideDetailPageType: 'cards-in-space-medal'
    },
    old_timer: {
        name: 'Old Timer',
        description: 'Awarded if you have been a Triplejack player for at least a year.',
        infoItemsCreator: ({ value }) => value ? [`${value.toLocaleString()} Year${value > 1 ? 's' : ''} on Triplejack`] : [],
        getImageUrl: ({ value }) => {
            if (value === undefined) {
                return;
            }
            const imageIndex = Math.min(Math.floor(value / 2), OLD_TIMER_MEDAL_IMAGE_URLS_BY_LEVEL.length - 1);
            return OLD_TIMER_MEDAL_IMAGE_URLS_BY_LEVEL[imageIndex];
        },
        sampleImageUrl: OLD_TIMER_LEVEL1_MEDAL_IMAGE_URL
    },
    riot: {
        name: 'High Roller Riot',
        description: 'Awarded if you win 10 High Roller Riot tournaments, and tracks the number of wins.',
        infoItemsCreator: ({ quantity }) => [getWinnerStr(quantity)],
        getImageUrl: ({ quantity }) => (quantity >= 10 ? RIOT_MEDAL_IMAGE_URL : undefined),
        sampleImageUrl: RIOT_MEDAL_IMAGE_URL
    },
    bad_beat_jackpot_winner: {
        name: 'Bad Beat Jackpot Winner',
        description: 'Awarded if you lose a bad beat hand and get the jackpot.',
        infoItemsCreator: ({ quantity, value }) => {
            const infoStrs = [getWinnerStr(quantity)];
            if (value) {
                infoStrs.push(`${value.toLocaleString()} Chips Won`);
            }
            return infoStrs;
        },
        getImageUrl: () => JACKPOT_MEDAL_IMAGE_URL,
        sampleImageUrl: JACKPOT_MEDAL_IMAGE_URL,
        gameGuideDetailPageType: 'bad-beat-jackpot'
    },
    sidebets_won: {
        name: 'Side Bets Won',
        description: "Ranks active Power Players according to how many side bets they've won.",
        rankingType: 'side-bets-won',
        getImageUrl: (playerMedal) => getImageUrlFromRankedMedal(playerMedal, SIDE_BETS_WON_MEDAL_IMAGE_URLS_BY_LEVEL),
        sampleImageUrl: SIDE_BETS_WON_LEVEL1_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ value }) => (value ? [`${value.toLocaleString()} Side Bets Won`] : []),
        gameGuideDetailPageType: 'side-bets-won-medal',
        rankedMedalImageUrls: SIDE_BETS_WON_MEDAL_IMAGE_URLS_BY_LEVEL
    },
    sidebet_tokens: {
        name: 'Side Bets Profit',
        description: 'Ranks active Power Players according to their overall profit with side bets.',
        rankingType: 'side-bets-profit',
        getImageUrl: (playerMedal) => getImageUrlFromRankedMedal(playerMedal, SIDE_BETS_PROFIT_MEDAL_IMAGE_URLS_BY_LEVEL),
        sampleImageUrl: SIDE_BETS_PROFIT_LEVEL1_MEDAL_IMAGE_URL,
        infoItemsCreator: ({ value }) => (value ? [`${getCurrencyAmountString(value, 'jacks')} Profit`] : []),
        gameGuideDetailPageType: 'side-bets-profit-medal',
        rankedMedalImageUrls: SIDE_BETS_PROFIT_MEDAL_IMAGE_URLS_BY_LEVEL
    }
};
